gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

    //const animationBlocks = document.querySelectorAll('.wp-block-create-block-kianimation');
    const mediaQuery = window.matchMedia("(min-width: 781px)");
    const isDesktop = mediaQuery.matches;

    const animationContainers = isDesktop
        ? document.querySelectorAll('.wp-block-create-block-kianimationcontainer')
        : [];
        
    animationContainers.forEach((container) => {
        const scrub = parseFloat(container.dataset.scrub) || false;
        const pin = container.dataset.pin === 'true' ? true : false;
        let start = container.dataset.start || "top 80%";
        let end = container.dataset.end || "bottom top";
        const reverse = container.dataset.reverse === 'true' ? true : false;
        const toggleActions = reverse ? "play reverse play reverse" : "play none none none";
        const markers = container.dataset.markers === 'true' ? true : false;

        console.log('pin: ' + pin);

        
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: container,
                pin: pin,
                scrub: scrub,
                start: start,
                end: end,
                toggleActions: toggleActions,
                markers: markers
            }
        });   
      
        container.querySelectorAll('.wp-block-create-block-kianimation').forEach((block, index) => {
            const animation = block.dataset.animation;
            const duration = block.dataset.duration || 1;
            const delay = parseFloat(block.dataset.delay) || 0;
            const easing = block.dataset.easing || 'power2.out';
            const blur = block.dataset.blur === 'true' ? true : false;
            const loop = block.dataset.loop === 'true' ? -1 : 0;
            const offset = block.dataset.offset || 200;


            switch (animation) {
                case 'slide-up':
                    tl.from(block, {
                        y: 200,
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;
                case 'slide-down':
                    tl.from(block, {
                        y: offset * -1, 
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none',
                        repeat: loop
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;
                case 'slide-left':
                    tl.from(block, {
                        x: 200,
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay      
                    );
                    break;
                case 'slide-right':
                    tl.from(block, {
                        x: -200,
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;
                case 'zoom-in':
                    tl.from(block, {
                        scale: 0.75,
                        y: 40,
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;                
                case 'zoom-out':
                    tl.from(block, {
                        scale: 1.5,
                        y: -40,
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;  
                case 'fade':
                    tl.from(block, {
                        opacity: 0,
                        duration: duration,
                        ease: easing,
                        delay: delay,
                        filter: blur ? 'blur(5px)' : 'none'
                    },
                    delay === 0 ? 0 : delay
                    );
                    break;                            


            }
        });
    });

    const animationBlocks = isDesktop
        ? Array.from(document.querySelectorAll('.wp-block-create-block-kianimation'))
            .filter(block => !block.closest('.wp-block-create-block-kianimationcontainer'))
        : Array.from(document.querySelectorAll('.wp-block-create-block-kianimation'));

    animationBlocks.forEach((block) => {

        const animation = block.dataset.animation;
        const duration = block.dataset.duration || 1;
        const delay = parseFloat(block.dataset.delay) || 0;
        const trigger = block.dataset.trigger === 'true' ? true : false;
        const reverse = block.dataset.reverse === 'true' ? true : false;
        const toggleActions = reverse ? "play reverse play reverse" : "play none none none";
        const markers = block.dataset.markers === 'true' ? true : false;
        const easing = block.dataset.easing || 'power2.out';
        const loop = block.dataset.loop === 'true' ? -1 : 0;

        switch (animation) {

            case 'slide-up':
                gsap.from(block, {
                    y: 200,
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;
            case 'slide-down':
                gsap.from(block, {
                    y: -200,
                    opacity: 0,
                    duration: 0.8,
                    ease: easing,
                    delay: delay,
                    repeat: loop,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;

            case 'slide-left':
                gsap.from(block, {
                    x: 200,
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 80%',
                        toggleActions: toggleActions,
                        markers: markers
                    }
                });                
                break;

            case 'slide-right':
                gsap.from(block, {
                    x: -200,
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 80%',
                        toggleActions: toggleActions,
                        markers: markers
                    }
                });            
                break;
            case 'zoom-in':
                gsap.from(block, {
                    scale: 0.75,
                    y: 40,
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;                
            case 'zoom-out':
                gsap.from(block, {
                    scale: 1.5,
                    y: -40,
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;  
            case 'flip-x':
                gsap.from(block, {
                    rotationX: -90,
                    transformPerspective: 1000,
                    transformOrigin: 'center center',
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;                
            case 'clip-reveal':
                gsap.from(block, {
                    clipPath: 'inset(100% 0% 0% 0%)',
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;    
            case 'fade':
                gsap.from(block, {
                    opacity: 0,
                    duration: duration,
                    ease: easing,
                    delay: delay,
                    scrollTrigger: {
                        trigger: block,
                        toggleActions: toggleActions,
                        start: 'top 80%',
                        markers: markers
                    }
                });
                break;                            
        }

    });

    // FIX Subnav links to adjust for animation
    const submenus = document.querySelectorAll('.ki-submenu-container');

    submenus.forEach((submenu) => {
        submenu.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');

                if (!href || !href.startsWith('#')) {
                    return;
                }

                const target = document.querySelector(href);

                if (!target) {
                    return;
                }

                //const scrolledPast = window.scrollY > target.offsetTop;
                //const scrolledPast = target.getBoundingClientRect().top <= 0;
                const scrolledPast = (target.firstElementChild || target).getBoundingClientRect().bottom <= 0;

                e.preventDefault();

                const newHref = scrolledPast
                    ? href.replace(/-section$/, '')
                    : href.endsWith('-section')
                        ? href
                        : `${href}-section`;

                const target2 = document.querySelector(newHref);
                if (target2) {
                    target2.scrollIntoView();
                    history.replaceState(null, '', newHref);
                }                


            });
        });
    });

});
